/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Page, Group, Copy, Title, BodyCopy, CTAs, Button, Form, Grid, GridSet, GridItem, TextField } from '@insticator/insticator-ui'; // iui-material
import SignInCTA from 'material/ctas/signin/signin';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/auth/completepasswordreset/completepasswordreset_styles';



/* ========== ~~~~~~~~~~ AUTH COMPLETE PASSWORD RESET ~~~~~~~~~~ ========== */
class CompletePasswordReset extends Component {
    constructor(props){
        super(props);
        this.formName = 'completepasswordreset';
        this.state = { ready: false }
    }
    componentDidMount() {
        const tokenUUID = this.props.tokenData.tokenUUID;
        if(tokenUUID) this.props.getAuthTokenData(tokenUUID)
    }
    componentDidUpdate(prevProps) {
        if(prevProps.tokenData.userUUID !== this.props.tokenData.userUUID && this.props.tokenData.tokenType === "RESET_PASSWORD") {
            this.setState({ ready: true });
        } else if (prevProps.tokenData.error !== this.props.tokenData.error || prevProps.tokenData.validToken !== this.props.tokenData.validToken) {
            if(!!this.props.tokenData.error || this.props.tokenData.validToken === false) this.props.displayErrorMessage(`Woops, something wrong: Your token has expired. Please try again later.`)
        }
    }
    handleSubmit = () => {
        const callData = this.getFormCallData();
        if(this.readyToSubmit(callData)) this.props.completeResetWithValidation(this.props.fields, callData, this.handleSucessfulReset, this.handleFailedPasswordReset)
    };
    getFormCallData = () => ({
        tokenUUID: this.props.tokenData.tokenUUID,
        userUUID: this.props.tokenData.userUUID,
        updatedPassword: this.props.fields.newPassword.value,
    });
    readyToSubmit = callData => {
        if(!this.dataReady(callData)) {
            this.props.displayErrorMessage('Woops, something wrong: We were unable to process your request. Please try again later.')
            return false;
        } else if (!this.passwordsMatch()) {
            this.props.displayErrorMessage(`Woops, something wrong: The entered passwords don't match. Please try again later.`)
            return false;
        }
        return true;
    };
    dataReady = (callData) => {
        const { tokenUUID, userUUID } = callData;
        return !!tokenUUID && !!userUUID;
    };
    passwordsMatch = () => this.props.fields.newPassword.value === this.props.fields.confirmedPassword.value;
    handleSucessfulReset = () => {
        this.props.moveToPage('auth/passwordupdated');
        const successMessage = 'Password successfully reset.';
        this.props.displaySuccessMessage(successMessage);
    };
    handleFailedPasswordReset = () => {
        this.props.displayErrorMessage('Woops, something wrong: We were unable to process your request. Please try again later.');
    };
    render() {
        const { newPassword, confirmedPassword } = this.props.fields;
        return(
            <Page name={this.formName}  klass={this.props.classes.completepasswordreset}>
                <Group name={`main`}>
                    <Copy>
                        <Title>
                            <h2>Reset Password</h2>
                        </Title>
                        <BodyCopy>
                            <p>{!!this.props.tokenData.email ? `Set a password for ${this.props.tokenData.email}` : ''}</p>
                        </BodyCopy>
                    </Copy>
                    <Form name={`completesignup`} editable={this.state.ready && !this.props.savingData} >
                        <Grid type={`fields`}>
                            <GridSet direction={`vertical`}>
                                <GridItem><TextField type={`password`} name={`newPassword`} value={newPassword.value} valid={newPassword.valid} formName={this.formName} placeholder={`Password`} label={`New Password`} info={`Use 8 or more characters with a mix of letters, numbers & symbols`} required /></GridItem>
                                <GridItem><TextField type={`password`} name={`confirmedPassword`} value={confirmedPassword.value} valid={confirmedPassword.valid} formName={this.formName} placeholder={`Password`} label={`Confirm Password`} info={``} required /></GridItem>
                            </GridSet>
                        </Grid>
                        <CTAs>
                            <Button type={'action'} disabled={!this.state.ready || this.props.savingData} action={this.handleSubmit} variant={`primary`} processing={this.props.savingData} operation={'save'} name={`submit`} text={`Set new password`} />
                        </CTAs>
                    </Form>
                </Group>
                <Group name={`callout`}>
                    <SignInCTA copy={'You were not trying to reset password?'} />
                </Group>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(CompletePasswordReset);
